import { render, staticRenderFns } from "./AddPackages.vue?vue&type=template&id=251bca86&scoped=true"
import script from "./AddPackages.vue?vue&type=script&lang=ts"
export * from "./AddPackages.vue?vue&type=script&lang=ts"
import style0 from "./AddPackages.vue?vue&type=style&index=0&id=251bca86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251bca86",
  null
  
)

export default component.exports